import { cn } from '@repo/tailwind-config/tailwind.functions'

import { useFormField } from '../forms/form'
import CurrencyInput, { CurrencyInputProps } from './currency-input'

export function ControlledCurrencyInput({ className, ...props }: CurrencyInputProps) {
  const { error } = useFormField()
  return (
    <CurrencyInput
      {...props}
      className={cn('w-full h-10', className)}
      errorMessage={error ? String(error?.message) : undefined}
    />
  )
}
